import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Componente para mostrar y gestionar módulos asignados a licencias
 */
const ModulosAsignados = ({
    objLicenciasModulo,
    product
}) => {
    return (
        <>
            {objLicenciasModulo.map((objLicModulo, indexModulo) => {
                const keyModulo = objLicModulo.idLicencia > 0
                    ? `mod-${product.idOrdenDetalle}-${objLicModulo.idLicencia}`
                    : `mod-empty-${product.idOrdenDetalle}-${indexModulo}`;

                // Si tiene licencia asignada al módulo
                if (objLicModulo.idLicencia > 0) {
                    return (
                        <Col key={keyModulo} className="pr-1 mb-2" style={{ cursor: 'pointer' }}>
                            <Link
                                to={`/licencias/detalle/${objLicModulo.idLicencia}`}
                                target="_blank"
                                className="stretched-link text-info position-relative"
                            >
                                <img className="mr-2" src="/img/pcautorizada20.png" alt="" />
                                {product.vCodigoBarras} #{objLicModulo.idLicencia}
                            </Link>

                            {/* Badges de estado si existen */}
                            {objLicModulo.Status && (
                                <>
                                    {objLicModulo.Status === "NO ACTIVADA" ? (
                                        <span className="ms-2 badge badge-soft-danger">
                                            {objLicModulo.Status}
                                        </span>
                                    ) : objLicModulo.Status.includes("VC ") ? (
                                        <span className="ms-2 badge badge-soft-warning">
                                            {objLicModulo.Status}
                                        </span>
                                    ) : (
                                        <span className="ms-2 badge badge-soft-success">
                                            {objLicModulo.Status}
                                        </span>
                                    )}
                                </>
                            )}

                            {objLicModulo.bCancelado === 1 && (
                                <>
                                    &nbsp;
                                    <span className="ms-2 badge badge-soft-danger">CANCELADA</span>
                                </>
                            )}
                        </Col>
                    );
                }

                // Si no hay licencia asignada al módulo - no mostrar nada (asignación es automática vía webhook)
                return null;
            })}
        </>
    );
};

ModulosAsignados.propTypes = {
    objLicenciasModulo: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired
};

export default ModulosAsignados;
